module.exports = __webpack_public_path__ + "img/elementheights_jasp.5390496a.png";